/* global axios */
import ApiClient from './ApiClient';

class VoipAnalyticsAPI extends ApiClient {
  constructor() { super('voip_analytics', { accountScoped: true }); }

  _q(filters) {
    const p = new URLSearchParams();
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach(x => p.append(`${k}[]`, x));
      else if (v !== null && v !== undefined && v !== '') p.append(k, v);
    });
    return p.toString();
  }
  funnel(f)       { return axios.get(`${this.url}/funnel?${this._q(f)}`); }
  financial(f)    { return axios.get(`${this.url}/financial?${this._q(f)}`); }
  byAgent(f)      { return axios.get(`${this.url}/by_agent?${this._q(f)}`); }
  byOrigin(f)     { return axios.get(`${this.url}/by_origin?${this._q(f)}`); }
  daily(f)        { return axios.get(`${this.url}/daily?${this._q(f)}`); }
  distance(f)     { return axios.get(`${this.url}/distance?${this._q(f)}`); }
  targets(month)  { return axios.get(`${this.url}/targets?month=${month || ''}`); }
  updateTargets(payload) { return axios.patch(`${this.url}/targets`, payload); }

  // Fase 2: blocos adicionais por tipo de operacao
  callsPerLead(f)    { return axios.get(`${this.url}/calls_per_lead?${this._q(f)}`); }
  attendanceRate(f)  { return axios.get(`${this.url}/attendance_rate?${this._q(f)}`); }
  leadSpeed(f)       { return axios.get(`${this.url}/lead_speed?${this._q(f)}`); }
  fcrRate(f)         { return axios.get(`${this.url}/fcr_rate?${this._q(f)}`); }
  // Layer 4+5: checklist de setup
  setupChecklist()   { return axios.get(`${this.url}/setup_checklist`); }
  // Phase 2.5 H: comparacao temporal
  compare(f)         { return axios.get(`${this.url}/compare?${this._q(f)}`); }
  // Phase 2.5 I: feed de resumos AI recentes
  recentSummaries(f) { return axios.get(`${this.url}/recent_summaries?${this._q(f || {})}`); }
}

export default new VoipAnalyticsAPI();
